import { MerchantDto } from '../../types/Merchant'
import { TranslatedEnum } from '../../types/TranslatedEnum'
import { makeCreate, makeGetListFromApi, makeGetSingleFromApi } from '../make-api'
import { SearchMerchantDto } from './SearchMerchantDto'

export type ValueListItemDto = {
  value: string
  textFr: string
  textEn: string
  priority?: number
  active: boolean
  contactClient: boolean
}
export type ValueListDto = {
  id: string
  sortMethod: 'priority' | 'alpha'
  defaultvalue: string | null
  items: ValueListItemDto[]
  expiresOn: number
}

export type ValueListItem = {
  id: string
  text: string
  contactClient: boolean
}

const configApi = {
  getOtherIncome: makeGetListFromApi<TranslatedEnum>('api/GetOtherIncomeType'),
  getWithdrawalReasons: makeGetSingleFromApi<ValueListDto>('api/GetWithdrawalReasons'),
  getBadReviewReasons: makeGetSingleFromApi<ValueListDto>('api/GetBadReviewReasons'),
  getMerchants: makeCreate<SearchMerchantDto, MerchantDto[]>('api/merchant/search'),
}

export default configApi
